import BaseAction from "./BaseAction";
import CustomerInteractionReducer from "../reducers/CustomerInteractionReducer";

class CustomerInteractionAction extends BaseAction {
  onClose = () => {};

  onCreateCustomer = () => {};
}

const action = new CustomerInteractionAction(CustomerInteractionReducer);

export default action;
